/**
 * Created by ys on 2018/4/3.
 */
import axios from 'axios';
import store  from './../store/index.js'
import {encryptSpec} from '../utils/zEncryptSpec.js';
import { Message } from 'iview';
import {encryptUtil} from '../utils/zEncryptUtil.js';
import router from '../router';
let pending = []; //声明一个数组用于存储每个ajax请求的取消函数和ajax标识
let cancelToken = axios.CancelToken;

let baseURL = window.config.BASE_URL;
 let ops = {
  scrollPanel: {
    scrollingX: false,
  },
  rail: {
    vRail: {
      pos: 'right',
        opacity: 0.5,
        background: '#7e8c8d'
    },
    hRail: {
      pos: 'bottom',
        opacity: 0.5,
        background: 'rgba(0, 0, 0, 0.2)'
    }
  },
  bar: {
    vBar: {
      keepShow: true,
        background: '#7e8c8d'
    },
    hBar: {
      keepShow: false,
        background: '#00a650'
    }
  },
   contentWidth: '10px',
};
let removePending = (config,pendingKey) => {
  for(let p in pending){
    if(pending[p].u === config.url + '&' + config.method && pending[p].key === pendingKey) { //当当前请求在数组中存在时执行函数体
      pending[p].f(); //执行取消操作
      pending.splice(p, 1); //把这条记录从数组中移除
    }
  }
}
// 登录
function loginHttp(methodStr, param,username,second = 10000,methods='post',needParam = true, isMobileCode = false) {
  // 1-/login/login 2-login/webLogin
  methodStr = needParam ? (isMobileCode ? "login/webLoginByMsg" : "login/webLogin") : "user/getCurrentUserSession";
  let certification1;
  let encryptInfo1;
  let md5Value;
  let params = {};
  let instance = null;
  let encrypt=new encryptSpec();
  certification1 = 0;
  encryptInfo1 = 1;
  if (instance == null) {
    instance = axios.create({
      transformRequest:[function (data) {
        let newData = ''
        for (let k in data) {
          newData += encodeURIComponent(k) + '=' + encodeURIComponent(data[k]) + '&'
        }
        return newData
      }]
    });
  }
  if(needParam){
    md5Value = encrypt.encryptLoginInfo(param);
    params = {
      certification: certification1,
      encryptInfo: encryptInfo1,
      params: md5Value
    }
  }else{
    md5Value = encrypt.encryptLoginInfo(param);
    params = {
      certification: certification1,
      encryptInfo: encryptInfo1,
      decryptSeed: encrypt.encryptLoginInfo("vcarecity"),
      params: md5Value
    };
  }
  
  instance.defaults.headers = {'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'};
  // 现在，在超时前，所有请求都会等待 1秒
  instance.defaults.timeout = second;
  instance.defaults.baseURL = baseURL;
  instance.defaults.withCredentials = true;
    // var url = baseURL + methodStr + "?certification="+ localStorage.getItem("certification") + "&encryptInfo=" + encryptInfo1 + "&params=" + encodeURIComponent(md5Value);
    // console.log(url);
    // console.log(methodStr + '\n'+ param);
  //}
  // 添加请求拦截器
  instance.interceptors.request.use(function (config) {
    //在发送请求之前做些什么
    config.url = methodStr;
    config.method= methods;
    // if(!needParam){
    //   config.params = params;
    //   config.headers = {"Authorization":"Bearer " + param.token,"Content-Type": "application/x-www-form-urlencoded; charset=UTF-8"};
    // }else{
      config.data = params;
    // }
    return config;
  }, function (error) {
    // 对请求错误做些什么
    return Promise.reject(error);
  });
  // 添加响应拦截器
  instance.interceptors.response.use(function (response) {
    var ret=response.data;
    if(ret.flag ===-10){
      return Promise.reject(ret.msg);
      // $state.go('login');
    }else if(ret.flag >= 0){
      let str=ret.objString;
      let result= needParam ? encrypt.decryptLoginResult(username, str) : encrypt.decryptLoginResult("vcarecity", str);
      ret.objString=result;
      var ret1 = JSON.parse(result);
      encrypt.setApiEncryptKeysForE(ret1.apiEncryptKeys.key1, ret1.apiEncryptKeys.key2, ret1.apiEncryptKeys.key3);
      return ret;
    }else if(ret.flag === -17){
      if(ret.obj){
        return ret;
      }else{
        return Promise.reject(ret.msg);
      }
      
    }else if(ret.flag < 0){
      return Promise.reject(ret.msg);
    }else {
      return Promise.reject(ret.msg || "服务器有误");
    }
  }, function (error) {
    // 对响应错误做点什么
    return Promise.reject(error);
  });
  return instance();
};
function publicHttp(methodStr, param,username,second = 10000,methods='post') {
  let certification1;
  let encryptInfo1;
  let md5Value;
  let params = {};
  let instance = null;
  let encrypt=new encryptSpec();
  param = JSON.stringify(param);
  md5Value = encrypt.encryptLoginInfo(param);
  certification1 = 0;
  encryptInfo1 = 1;
  if (instance == null) {
    instance = axios.create({
      transformRequest:[function (data) {
        let newData = ''
        for (let k in data) {
          newData += encodeURIComponent(k) + '=' + encodeURIComponent(data[k]) + '&'
        }
        return newData
      }]
    });
  }
  params = {
    certification: certification1,
    encryptInfo: encryptInfo1,
    params: md5Value
  };
  console.log(methodStr + '\n'+ param);
  instance.defaults.headers = {'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'};
  // 现在，在超时前，所有请求都会等待 1秒
  instance.defaults.timeout = second;
  instance.defaults.baseURL = baseURL;
  instance.defaults.withCredentials = true;
  // 添加请求拦截器
  instance.interceptors.request.use(function (config) {

    //在发送请求之前做些什么
    config.url = methodStr;
    config.method= methods;
    config.data = params;
    return config;
  }, function (error) {
    // 对请求错误做些什么
    return Promise.reject(error);
  });
  // 添加响应拦截器
  instance.interceptors.response.use(function (response) {
    var ret=response.data;
    if(ret.flag ===-10){
      // $state.go('login');
    }else if(ret.flag >= 0){
      let str=ret.objString;
      let result=encrypt.decryptLoginResult('vpublic', str);
      ret.objString=result;
      return ret;
    }else if(ret.flag < 0){
      return Promise.reject(ret.msg);
    }else {
      return Promise.reject("服务器有误");
    }
  }, function (error) {
    // 对响应错误做点什么
    return Promise.reject(error);
  });
  return instance();
};
//http请求
function reqHttp(methodStr, param,index=1,second = 90000, upPictrue = 1,methods='post') {
  //所有请求都要放当前的userId和agencyId
  var self = this;
  var pendingKey = 0;
  if(typeof(param)!= "string" ){
    if(!param.userId){param.userId = store.state.user.userId;}
    if(!param.agencyId){param.agencyId = store.state.user.agencyId;}
    if(index==2&&param.pendingKey!=undefined){
      pendingKey = param.pendingKey;
    }
    param = JSON.stringify(param);
  }
  // console.log(methodStr);
  // console.log(param);
  let params={};
  let instance = null;
  let encrypt = new encryptSpec();
  let encryptInfo=encrypt.getResponseKeyForI();
  var md5Value=encrypt.encryptParams(param,encryptInfo);

  if(consoleAble()){//如果是本地调试才显示
    var url = baseURL + methodStr + "?certification="+ localStorage.getItem("certification") + "&encryptInfo=" + encryptInfo + "&params=" + encodeURIComponent(md5Value);
    // console.log(url);
    // console.log(methodStr + '\n'+ param);
  }

  if(instance==null){
    instance = axios.create({
      transformRequest:[function (data) {
        let newData = ''
        for (let k in data) {
          newData += encodeURIComponent(k) + '=' + encodeURIComponent(data[k]) + '&'
        }
        return newData
      }]
    });
  }
  if (upPictrue == 2) {
    instance.defaults.headers = {'Content-Type': undefined};
    var oMyForm = new FormData();
    //oMyForm.append("certification", localStorage.getItem("certification"));
    oMyForm.append("encryptInfo", encryptInfo);
    oMyForm.append("params", md5Value);
    params = oMyForm;
  } else {
    params = {
      //certification: localStorage.getItem("certification"),
      encryptInfo: encryptInfo,
      params: md5Value
    }
    instance.defaults.headers = {'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'};
  }
  // 现在，在超时前，所有请求都会等待 1秒
  instance.defaults.timeout = second;
  instance.defaults.baseURL = baseURL;
  instance.defaults.withCredentials = true;
  // 添加请求拦截器
  instance.interceptors.request.use(function (config) {
    //在发送请求之前做些什么
    config.url = methodStr;
    config.method= methods;
    config.data = params;
    if(index==2){
      removePending(config,pendingKey); //在一个ajax发送前执行一下取消操作
    }
    if(index==2){
      config.cancelToken = new cancelToken((c)=>{
        // 这里的ajax标识我是用请求地址&请求方式拼接的字符串，当然你可以选择其他的一些方式
        pending.push({ u: config.url + '&' + config.method,key:pendingKey, f: c });
      });
    }
    return config;
  }, function (error) {
    // 对请求错误做些什么
    return Promise.reject(error);
  });
  // 添加响应拦截器
  instance.interceptors.response.use(function (response) {
    //console.log("请求=" + methodStr);
    //console.log(response);
    if(index==2) {
      removePending(response.config,pendingKey);
    }
    var ret=response.data;
    if(ret.flag ===-10){
      localStorage.removeItem("certification");
      router.push({path: '/login'});
    }else if(ret.flag != undefined && ret.flag >= 0){
      let str=ret.objString;
      var result= str ? encrypt.decryptResult(str,encryptInfo) : null;

      // console.log(methodStr);
      // console.log(result);
      ret.objString=result;
      if(consoleAble()){//如果是本地调试才显示
        // console.log(methodStr);
        //console.log(ret);
        // console.log(JSON.parse(ret.objString));
      }
      //打印另一个平台的接口信息用
      //  console.log("textzcc"+encrypt.decryptResult(
      //    "HYfW+YwnECBQKXW/I/GlaYbkM6ETJiKD/GckCVeu1ENwoZHBTNgbfDJNtWsCWUDr3GkcusxeLvq9gTzLmk9zvRsNjeLxWyH+kJPRNHTTVrZAUBTazFmUl9JeyzVXARE3k8Lt4xXL9xY3iPsosxX26+YhcexDbWbm8Yidws4Lie5g4e1L3DATcY3FHNJwMHIPptNJ81XC52jwTRzYYx9WnMqE6ZvAqJbT5xmV9nkxBYn/rZAhC5qNeiGfZcAwT9AOhbOcEpLxvIwq9wiRHiBY+uFdqr5dz5UkQcX8m/eK0FTlaizABoSMSineTBu5jhXMcRT+h4LE3nUyW35cPARwZahLHC+rVK2pPgC5DD2VDc8wCwCYCvknDUpZhqDaFU+oPfWvAf32N057SNmfcgbfzVrkNMP2F230N4mXXpv0yxRZjO1pvJpzeuE3e/l9gbkkVHu+WGYNRUTsl7tirh27yVHo+QWfZlx91DW3nNpnSqA8ySsrMvh7L7e53Q+aLstjAi8r9GM1DjmJZ42X3VFev9T93NaZcO4HgD2Xy6aPZsZIKXRW102YCFTtlutcsGl7kcQt/LU//UGLWAaEgmOeDQ==",
      //    1049));
      return ret;
    }else if(ret.flag === -13){
      return Promise.reject(ret.msg);
    } else {
      Message.error(ret.msg);
      return Promise.reject(ret.msg);
    }
  }, function (error) {
    if(error != 'Cancel'){//不是取消请求则返回异常
      if(error.code == 'ECONNABORTED'){//这里的超时是前端设置的timeout,后端设置了50秒（超时504但无法获取该状态），前端先设置45s，
        return Promise.reject("请求超时");
      }
      if(error.message == "Network Error"){
        //window.location.href="static/netWorkError.html";
      }
      return Promise.reject("系统异常");
    }else{
      return Promise.reject("Cancel");
    }
  });
  return instance();
};
/**
 * 图片上传
 * methodStr 请求地址
 * param 请求的参数(对象)
 * upPicture 图片文件
 * second 超时时间
 */
function uploadImg(methodStr, param, upPictrue,fileType,methods = 'post') {
  //所有请求都要放当前的userId和agencyId
  var pendingKey = 0;
  if (typeof(param) !== "string") {
    param.userId = store.state.user.userId;
    if(!param.agencyId){param.agencyId = store.state.user.agencyId;}
    param = JSON.stringify(param);
  }
  let params = {};
  let instance = null;
  let encrypt = new encryptSpec();
  let encryptInfo = encrypt.getResponseKeyForI();
  let md5Value = encrypt.encryptParams(param, encryptInfo);
  if(consoleAble()){//如果是本地调试才显示
    var url = baseURL + methodStr + "?certification="+ localStorage.getItem("certification") + "&encryptInfo=" + encryptInfo + "&params=" + encodeURIComponent(md5Value);
    console.log(url);
    console.log(methodStr + '\n'+ param);
  }
  if (instance === null) {
    instance = axios.create();
  }
  var formData = new FormData();
  formData.append("certification", localStorage.getItem("certification"));
  formData.append("encryptInfo", encryptInfo);
  formData.append("params", md5Value);
  formData.append(fileType, upPictrue);
  params = formData;
  // 现在，在超时前，所有请求都会等待 1秒
  instance.defaults.baseURL = baseURL;
  instance.defaults.withCredentials = true;
  instance.defaults.contentType=false;
  instance.defaults.async=false;
  instance.defaults.processData=false;
  // 添加请求拦截器
  instance.interceptors.request.use(function (config) {
    //在发送请求之前做些什么
    config.url = methodStr;
    config.method = methods;
    config.data = params;
    return config;
  }, function (error) {
    // 对请求错误做些什么
    return Promise.reject(error);
  });
  // 添加响应拦截器
  instance.interceptors.response.use(function (response) {
    console.log(response);
    let ret = response.data;
    if (ret.flag === 0) {
      let str = ret.objString;
      var result = encrypt.decryptResult(str, encryptInfo);
      ret.obj = result;
      return ret;
    } else {
      return ret;
    }
  }, function (error) {
    console.log(error);
  });
  return instance();
};
/**
 * 模拟APP请求珠海消防管家的接口
 */
function simulatePhoneHttp(methodStr, param,index=1,second = 45000, upPictrue = 1,methods='post'){
  let instance = axios.create();
  instance.defaults.headers = {'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'};
  instance.defaults.timeout = 1000;
  instance.defaults.withCredentials = true;
  instance.defaults.url = "http://192.168.10.112:8088/FireManagerService/servlet/getSafeData";
  instance.defaults.params={
    userId:7210,
    agencyId:67489,
    certificate:'1554166734413b9274bd08f24fd3b6c1'
  };

  instance.interceptors.response.use(function (response) {
  }, function (error) {
    console.log(error);
  });
  return instance();
};
//是否启动调试，打印
function consoleAble(){

  let consoleAble = false;
  let url = window.location.host;
  if(url.indexOf("localhost") >=0 || url.indexOf("192") >=0 || url.indexOf("social.test") >=0){
    consoleAble = true;
  }
  return consoleAble;
}
function openYP(code){
  //let baseUrl = "http://fire.vcarecity.com/";
  let baseUrl =  window.config.FMMP_URL;
  if (!!window.ActiveXObject || "ActiveXObject" in window){
    window.open(baseUrl + "login/to_yp?code=" + code,'_blank');
  }else{
    // 如果不能打开可能是没有IE浏览器或者没装注册表，向用户提示
    let openUrl = "openIE:" + baseUrl +"login/to_yp?code=" + code;
		window.protocolCheck(openUrl, function () {
      // 提示
      Message.warning({
        render: h => {
          return h('div', [
              h('br'),
              h('p', '提示：无法打开IE浏览器，是否缺少注册表？'),
              h('br'),
              h('a',{
                attrs:{href:"../static/utils/openIE.reg",download:"openIE.reg"},
              }, '点击可下载，下载后双击可运行'),
              h('br'),
              h('br'),
          ])},
        duration: 1000*15,
        closable: true
      });
		});
    window.location.href = openUrl;// 使用IE打开
  }
}
export default {
  loginHttp,
  openYP,
  reqHttp,
  uploadImg,
  publicHttp,
  baseURL,
  ops
}



// WEBPACK FOOTER //
// ./src/sevice/API.js